module.exports = __webpack_public_path__ + "img/weatherpedia-pwa10.66aadf0b.jpg";